import { makeMediaQueryStore } from './make_media_query_store';

const BREAKPOINTS = {
  NARROW_VIEWPORT: 640,
  WIDE_VIEWPORT: 1280,
};

export const useIsNarrowViewport = makeMediaQueryStore(
  `(max-width: ${BREAKPOINTS.NARROW_VIEWPORT}px)`,
);

export const useIsWideViewport = makeMediaQueryStore(
  `(max-width: ${BREAKPOINTS.WIDE_VIEWPORT}px)`,
);
